export default {
    ADD_FILTER(state, dataToSave) {
        let { name, data } = dataToSave;
        state.filterContainer[name] = data;
    },
    UPDATE_FILTER(state, dataToUpdate) {
        let { name, data } = dataToUpdate;
        state.filterContainer[name] = Object.assign(state.filterContainer[name], data);
    }
}